import React from 'react';
import { Text } from '../atoms/Text';
import { Heading } from '../atoms/Heading';
import { Field } from '../molecules/Field';
import Illustration from '../molecules/Illustration';

function PathwayForm() {
    return (
        <div className="flex flex-col gap-2">
            <Illustration type="pathway" classes="w-full object-center " />
            <div className="flex flex-col gap-4 p-6 lg:px-12">
                <Text>Step 1 of 3</Text>
                <Heading h1>What&apos;s your main goal?</Heading>

                <Text body classes="mb-4">
                    Pick the goal you'd most like to focus on. It's ok if you have more than one, we can come back to
                    the others later - but for now, keeping focused makes it much easier to tackle your habits!
                </Text>

                <Field
                    name="pathway"
                    label="Select the 1 goal that you most want to focus on:"
                    input="multiselect"
                    isRequired
                    inputOptions={{
                        options: [
                            {
                                icon: 'lose-weight',
                                label: 'Manage Weight',
                                value: 'weight',
                            },
                            {
                                icon: 'move-more',
                                label: 'Move More',
                                value: 'activity',
                            },
                            {
                                icon: 'drink-less',
                                label: 'Drink Less',
                                value: 'alcohol',
                            },
                            {
                                icon: 'quit-smoking',
                                label: 'Quit Smoking',
                                value: 'smoking',
                            },
                        ],
                    }}
                />
            </div>
        </div>
    );
}

export default PathwayForm;
